import { useEffect, useState } from "react";
import apiService from "services/BackendApi/BackendApi";

export function useNewsPage(props) {
  const { page, respp, location, sortby, orderby } = props;
  const [pageContent, setPageContent] = useState({
    isLoading: false,
    isError: false,
    payload: null,
    error: null,
  });

  useEffect(() => {
    setPageContent((prevPageContent) => ({
      ...prevPageContent,
      isLoading: true,
    }));
    const apiS = () => {
      apiService
        .GetSearchQuery({
          params: {
            sortby: sortby,
            page: page,
            contenttype: "news",
            orderby: orderby,
          },
        })
        .then((response) => {
          setPageContent((prevPageContent) => ({
            ...prevPageContent,
            isError: false,
            payload: {
              ...response.data,
            },
          }));
        })
        .catch((error) => {
          console.log("ErroRRRRRR");
          console.log(Error);
          setPageContent((prevPageContent) => ({
            ...prevPageContent,
            isError: true,
            isLoading: false,
            error: error?.message,
          }));
        })
        .finally(() => {
          setPageContent((prevPageContent) => ({
            ...prevPageContent,
            isLoading: false,
          }));
        });
    };
    apiS();
  }, [page, sortby]);

  return pageContent;
}

// Local Variables:
// apheleia-inhibit: nil
// End:
